/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Form, Grid } from '@mairistem/composants';
import { ParentForm, TypeComponent } from '@mairistem/administres-utils';

import { GridColumnDivider, Section } from '@/components/Common';
// import ParentForm from '@/components/Common/ParentForm';
import { AssistantContext } from '@/contexts';
import { Steps } from '@/types';

const StepFiliation = () => {
  const {
    filiationInconnueParent1,
    filiationInconnueParent2,
    parent1,
    parent2,
    errors,
    onChange,
  } = React.useContext(AssistantContext);

  const errorsStep = errors?.[Steps.Filiation] || {};

  return (
    <Grid as={Form} padded centered>
      <Grid.Row style={{ paddingTop: 0 }}>
        <Grid.Column>
          <Section title="PARENTS">
            <Grid centered>
              <Grid.Column computer={7} mobile={16}>
                <ParentForm
                  numeroParent={1}
                  parent={parent1}
                  filiationInconnue={filiationInconnueParent1}
                  errors={errorsStep?.parent1}
                  onChange={onChange}
                  typeComponent={TypeComponent.RECENSEMENT}
                />
              </Grid.Column>
              <GridColumnDivider />
              <Grid.Column computer={7} mobile={16} style={{ marginLeft: 0 }}>
                <ParentForm
                  numeroParent={2}
                  parent={parent2}
                  filiationInconnue={filiationInconnueParent2}
                  errors={errorsStep?.parent2}
                  onChange={onChange}
                  typeComponent={TypeComponent.RECENSEMENT}
                />
              </Grid.Column>
            </Grid>
          </Section>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default StepFiliation;
